import { apiService } from '../services/apiService';

// Simple wrapper for employee notes API to keep future expansion easy
export interface GetEmployeeNotesParams {
  workplaceId: number;
  date?: string;
}

export const getEmployeeNotes = async ({ workplaceId: _workplaceId, date }: GetEmployeeNotesParams): Promise<any> => {
  const queryParams = [`page=1`, `itemsPerPage=50`];
  if (date) queryParams.push(`date=${date}`);
  const query = `employee_notes?${queryParams.join('&')}`;
  const data = apiService.responseHandler(await apiService.get(query));
  return data;
};

export const getEmployeeNoteById = async (id: number): Promise<any> => {
  const response = await apiService.get(`employee_notes/${id}`);
  return apiService.responseHandler(response);
};

export const createEmployeeNote = async (payload: { workplaceId: number; authorId?: number; note: string; date?: string; }): Promise<any> => {
	const cleanNote = payload.note.replace(/<[^>]*>/g, '');
	const body: any = { note: cleanNote };
	// NOTE: API mapping is inconsistent across environments. `author` may represent the assigned-to user
	// while `assignToUser` represents the actual creator in some cases. We allow both fields to be set.
	if (payload.authorId) body.author = `api/users/${payload.authorId}`;
	if (payload.workplaceId) body.workplace = `api/workplaces/${payload.workplaceId}`;
	if (payload.date) body.date = payload.date;

  const response = await apiService.post('employee_notes', body);
  return apiService.responseHandler(response);
};

export const updateEmployeeNote = async (id: number, payload: { workplaceId?: number; authorId?: number; note: string; date?: string; }): Promise<any> => {
	const cleanNote = payload.note.replace(/<[^>]*>/g, '');
	const body: any = { note: cleanNote };
	if (payload.authorId) body.author = `api/users/${payload.authorId}`;
	if (payload.workplaceId) body.workplace = `api/workplaces/${payload.workplaceId}`;
	if (payload.date) body.date = payload.date;

  const response = await apiService.put(`employee_notes/${id}`, body);
  return apiService.responseHandler(response);
};

export const deleteEmployeeNote = async (id: number): Promise<any> => {
  const response = await apiService.delete(`employee_notes/${id}`);
  return apiService.responseHandler(response);
};

export const employeeNotesService = {
  getEmployeeNotes,
  getEmployeeNoteById,
  createEmployeeNote,
  updateEmployeeNote,
  deleteEmployeeNote,
};

export default employeeNotesService;
